/**
 * @generated SignedSource<<43b1440858a3674b82804c17e8618e94>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditorTranslateButton_data$data = {
  readonly translateTextBlock?: string | null;
  readonly " $fragmentType": "EditorTranslateButton_data";
};
export type EditorTranslateButton_data$key = {
  readonly " $data"?: EditorTranslateButton_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditorTranslateButton_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "id"
    },
    {
      "kind": "RootArgument",
      "name": "to"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "translate"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": require('./EditorTranslateButtonRefetchQuery.graphql')
    }
  },
  "name": "EditorTranslateButton_data",
  "selections": [
    {
      "condition": "translate",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "id",
              "variableName": "id"
            },
            {
              "kind": "Variable",
              "name": "to",
              "variableName": "to"
            }
          ],
          "kind": "ScalarField",
          "name": "translateTextBlock",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "d3989c8ff4a60ce25a5b098a05bf2419";

export default node;
